export default __webpack_public_path__ + "images/FC.8b76273.png";